import { useContext } from 'react';

import type { BaseComponentProps } from '../../../../types/common';
import { H6, H7, P3 } from '../../Typography';

import { StandardCardSharedPropsContext } from './context';
import type { StandardCardProps } from './types';

export interface StandardCardContentSubtitleProps extends BaseComponentProps {
  /**
   * The subtitle to display.
   */
  subtitle: string;

  /**
   * Whether the subtitle should be truncated.
   */
  textOverflowEllipsis?: boolean;
}

const getSubtitleTypography = (layout: StandardCardProps['layout']) => {
  switch (layout) {
    case 'horizontal':
      return H7;
    case 'square':
      return H6;
    default:
      return P3;
  }
};

export const ContentSubtitle: React.FC<StandardCardContentSubtitleProps> = ({
  subtitle,
  textOverflowEllipsis = true,
}) => {
  const { layout, disabled } = useContext(StandardCardSharedPropsContext);
  const Subtitle = getSubtitleTypography(layout);

  return (
    <Subtitle
      color={disabled ? 'disabled' : 'secondary'}
      textOverflowEllipsis={textOverflowEllipsis}
    >
      {subtitle}
    </Subtitle>
  );
};
